<template>
  <div class="panel">
    <div class="plan">
      <div>
        <img :src="imgUrl1" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "companyProfile",
  components: {},
  props: {
    imgUrl: Array
  },
  data() {
    return {
      imgUrl1: ""
    };
  },
  destroyed() {},
  mounted() {
    this.dd();
  },
  methods: {
    dd() {
      this.imgUrl1 = this.imgUrl[0];
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.panel {
  background: #f7f6f9;
  margin: 0.1rem 0.1rem;
  color: #333333;
  font-size: 0.14rem;
}
// @import './companyProfile.scss'
</style>


// WEBPACK FOOTER //
// src/pages/Index/companyProfile/index.vue